import client from "../client";

export type InitiateDepositRequest = {
  wallets: {
    wallet_id: string;
    amount: number;
    remark: string;
  }[];
  route: string;
};

export const initiateDeposit = (data: InitiateDepositRequest) => {
  return client({
    query: `
    mutation InitiateDeposit($input: InitiateDepositInput) {
      initiate_deposit(input: $input) {
       url
      }
    }
  `,
    variables: {
      input: data
    }
  });
};

export const validatePayment = (sessionId: string) => {
  return client({
    query: `
    query ValidatePayment($input: VerifyPaymentInput) {
      verify_payment(input: $input) {
        success
        order_id
        payment_id
        payment_display_id
        order_display_id
        payment_status
      }
    }
  `,
    variables: {
      input: {
        session_id: sessionId
      }
    }
  });
};

export const cancelPayment = (orderId: string) => {
  return client({
    query: `
    mutation CancelPayment($input: CancelPaymentInput) {
      cancel_payment(input: $input) {
        success
      }
    }
  `,
    variables: {
      input: {
        order_id: orderId
      }
    }
  });
};
